module.exports = __webpack_public_path__ + "media/images/marisa-2e8ada5e50c3d18d2bc3f22dfb6e81b6.png";